import { ReactNode, useRef, ReactElement } from 'react'
import { useRouter } from 'next/router'
import { Link } from '@platform/ui-kit'
import { InternalSidebarNavigation } from '@platform/shared-components'

import WebsiteLayout from '../website-layout'
import { useUpdateHeader } from '../../hooks/use-update-header'
import { HEADER_THEMES } from '../../utils/constants'
import { useCleanHeader } from '../../hooks/use-clean-header'
import { TalentNewsletterSections } from '../../components/talent/newsletter'

import styles from './styles.module.scss'

type FAQLayoutProps = {
  children: ReactNode
}

export const FAQLayout = ({ children }: FAQLayoutProps) => {
  const router = useRouter()
  const faqRef = useRef<HTMLElement | null>(null)
  const newsletterRef = useRef<HTMLElement | null>(null)
  const { asPath } = router
  const links = [
    {
      href: '/faq/talent',
      label: 'For talent',
      isActive: asPath.includes('/faq/talent'),
    },
    {
      href: '/faq/companies',
      label: 'For companies',
      isActive: asPath.includes('/faq/companies'),
    },
  ]

  useUpdateHeader(faqRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useUpdateHeader(newsletterRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useCleanHeader()

  return (
    <>
      <div className={styles['faq-layout-container']}>
        <section className={styles['faq-section']} ref={faqRef}>
          <h1 className={styles['faq-title']}>Frequently Asked Questions</h1>
          <p className={styles['support-text']}>
            Don&apos;t see what you&apos;re looking for?{' '}
            <Link
              className={styles['support-link']}
              size="large"
              href="/contact-us"
              prefetch={false}
            >
              Contact us
            </Link>
          </p>
          <div className={styles['faq-content']}>
            <InternalSidebarNavigation links={links} />
            <div className={styles['content-wrapper']}>{children}</div>
          </div>
        </section>
      </div>
      <TalentNewsletterSections ref={newsletterRef} />
    </>
  )
}

export const FAQLayoutPage = (page: ReactElement) => <WebsiteLayout>{page}</WebsiteLayout>

FAQLayout.getLayout = FAQLayoutPage

export default FAQLayout
